<template>
  <div class="volunteer-container">
    <div class="block-title">志愿者</div>
    <div class="detail detail_msg active">
      <p>本基金会根据工作计划常年招募志愿者。志愿者可从基金会网站、微信公众号等多个渠道了解服务需求信息，填报相关申请表格后通过电子邮件等方式递交至基金会秘书处。申请经本基金会审核确认后即成为本基金会注册志愿者。在履行志愿服务之前，基金会将与志愿者签订志愿者服务协议书。</p>
      <br>
      <p class="title">选拔条件：</p>
      <p>（一）年满18周岁，身体健康；</p>
      <p>（二）具有良好的思想道德品质和社会奉献精神；</p>
      <p>（三）遵守国家的各项法律、法规和规章制度；</p>
      <p>（四）具备为本基金会组织开展的活动提供志愿服务所必需的技能和时间。</p>
      <hr>
      <p class="title">志愿者可享受的权利</p>
      <p>（一）参加志愿服务活动；突发事件。</p>
      <p>（二）接受本基金会提供的与服务相关的志愿服务培训；</p>
      <p>（三）获得从事志愿服务的必需条件和必要保障；</p>
      <p>（四）优先获得志愿者组织和其他志愿者提供的服务；</p>
      <p>（五）对志愿服务工作提出意见和建议；</p>
      <p>（六）相关法律、法规、政策所赋予的权利；</p>
      <p>（七）可申请取消注册志愿者身份。</p>
      <hr>
      <p class="title">志愿者应履行的义务</p>
      <p>（一）遵守中国法律法规，志愿服务，不计报酬；</p>
      <p>（二）遵守本基金会的有关规定，履行服务承诺，服从管理，按照本基金会管理部门的安排积极参加服务活动；</p>
      <p>（三）自觉抵制任何以志愿者身份从事的赢利活动或其他违背社会公德的活动（行为）；</p>
      <p>（四）自觉维护本基金会志愿者的形象；</p>
      <p>（五）自觉维护服务对象的合法权益；</p>
      <p>（六）履行相关法律法规及其他规章制度规定的其它义务。</p>
      <p>您可以在此&nbsp;<a class="doc" href="http://cloud.changanfoundation.com/0301-5.docx">下载申请表格</a></p>
      <p>或直接通过网站联系我们：</p>
      <p></p>
      <br><br>

      <submitForm />
    </div>
  </div>
</template>

<script>
import submitForm from './form'

export default {
  components: {
    submitForm
  },
  data() {
    return {
    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.volunteer-container {
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0,0,0,.1);
  }

  a.doc {
    color: $primary;
    &:hover {
      color: #0056b3;
      text-decoration: underline;
    }
  }

  p {
    line-height: 30px;
    font-size: 14px;
    color: #222;

    &.title {
      text-indent: 0;
      margin-bottom: 0;
      font-weight: bold;
      line-height: 40px;
      border: 0;
    }
  }
}
</style>
